<template>
  <div>
    <RingbaPlan
      :is-loading="isBillingSettingsLoading"
    />

    <AccountBalance
      :is-loading="isBillingSettingsLoading"
    />

    <RechargeSettings
      :is-loading="isBillingSettingsLoading"
      :billing-settings="billingPlan.billingSettings"
    />

    <CreditCards />

    <TransactionHistory />

    <MonthlyBilling />

  </div>
</template>

<script>
import messages from '../locales';
import { mapState, mapActions } from 'vuex';
import sharedMessages from '@/core/locales';
import RingbaPlan from './RingbaPlan';
import AccountBalance from './AccountBalance';
import RechargeSettings from './RechargeSettings';
import CreditCards from './CreditCards';
import TransactionHistory from './TransactionHistory';
import MonthlyBilling from './MonthlyBilling';
export default {
  name: 'BillingSettings',
  components: {
    RingbaPlan,
    AccountBalance,
    RechargeSettings,
    CreditCards,
    TransactionHistory,
    MonthlyBilling
  },
  data() {
    return {
      isBillingSettingsLoading: true,
    }
  },
  computed: {
    ...mapState('billingSettingsStore', ['billingPlan']),
  },
  async created() {
    await this.getBillingPlan();
    this.isBillingSettingsLoading = false;
    await this.getPricingPlan();
  },
  methods: {
    ...mapActions('billingSettingsStore', ['getBillingPlan', 'getPricingPlan']),
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en',
  },
};
</script>